

























































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import JdiContent from "@/components/JdiContent.vue"
import JdiPreview from "@/components/JdiPreview.vue"
import JdsBreakdown from "@/design-system/patterns/Breakdown/JdsBreakdown.vue"
import JdsBreakdownItem from "@/design-system/patterns/Breakdown/JdsBreakdownItem.vue"
import JdsMoney from "@/design-system/components/Money/JdsMoney.vue"
import JdsButton from "@/design-system/components/Button/JdsButton.vue"
import JdiDocs from "@/components/JdiDocs.vue"
import JdsBreakdownHeading from "@/design-system/patterns/Breakdown/JdsBreakdownHeading.vue"
import JdsSpotlight from "@/design-system/patterns/Spotlight/JdsSpotlight.vue"
@Component({
    components: {JdsSpotlight, JdiDocs, JdsButton, JdsMoney, JdiPreview, JdiContent}
})
export default class Spotlight extends Vue {

    reach = '10000'
    loadingReach = false

    randomizeReach() {
        this.loadingReach = true
        setTimeout(() => {
            this.loadingReach = false
            if (Math.random() < 0.5) {
                this.reach = Math.round(Math.random() * 500) * 1000 + ''
            } else {
                this.reach = (Math.round(Math.random() * 5000) * 1000) + ' - ' +
                    (Math.round(Math.random() * 5000) * 1000)
            }
        }, 850)
    }

}
